import onGetRelatedTeamMembers from './onGetRelatedTeamMembers';
import onRemoveMember from './onRemoveMember';

export default { onRemoveMember, onGetRelatedTeamMembers };
